import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Disable React error overlay for Firefox mobile in development mode
if (process.env.NODE_ENV === 'development') {
  const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('firefox');
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (isFirefox || isMobile) {
    console.log('Disabling React error overlay for Firefox/mobile');
    
    // Override the error overlay iframe creation
    const originalCreateElement = document.createElement;
    document.createElement = function(tagName: string, options?: ElementCreationOptions) {
      if (tagName?.toLowerCase() === 'iframe' && 
          (arguments.length === 0 || 
           arguments[0] === 'iframe' || 
           String(arguments[0]).includes('react-error-overlay'))) {
        console.log('Blocked React error overlay iframe creation');
        return originalCreateElement.call(this, 'div') as any;
      }
      return originalCreateElement.call(this, tagName, options);
    };
    
    // Override console.error to suppress React DevTools error overlay
    const originalConsoleError = console.error;
    console.error = function(...args: any[]) {
      const errorMessage = args.join(' ');
      if (errorMessage.includes('react-error-overlay') || 
          errorMessage.includes('Script error') || 
          errorMessage.includes('handleError')) {
        console.log('Suppressed React error overlay:', errorMessage);
        return;
      }
      originalConsoleError.apply(console, args);
    };
    
    // Set environment variable to disable error overlay
    if (typeof window !== 'undefined') {
      (window as any).__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = {
        isFiberMounted: () => false,
        onCommitFiberRoot: () => {},
        onCommitFiberUnmount: () => {},
      };
    }
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
